<template>
  <div class="raft-js-bio-data-window-wrapper">
    <BIconSearch
      @click="loadEntity"
      alt="Show Material Data"
      data-test="show-material"
      :id="iconSearchId"
    />
    <b-popover
      :target="iconSearchId"
      data-test="outside-vif"
      :id="popoverId"
      placement="right"
      triggers="click blur"
    >
      <raft-busy v-if="isLoading" busy-text="Loading..." />
      <template v-else-if="bioMaterial">
        <BioMaterialRender
          v-if="materialId"
          :bio-material="bioMaterial"
          :display-field-data="displayData"
          data-test="inside-vif"
          :material-type-label="materialTypeLabel"
        />
      </template>
      <template v-else>
        <ErrorStateLinks />
      </template>
    </b-popover>
  </div>
</template>

<script>
import { BIconSearch } from "bootstrap-vue";
import BioMaterialRender from "./BioMaterialRender.vue";
import { restClient, jsonClient } from "../../lib/raftApi";
import RaftBusy from "../RaftBusy.vue";
import ErrorStateLinks from "../raft/ErrorStateLinks.vue";

export default {
  name: "BioMaterialDataWindow",
  data() {
    return {
      bioMaterial: {},
      displayData: {},
      isLoading: false,
      // For B3 Bio Summary page which doesn't have access to Vue store
      bioMaterialsSupportingPlasmidVectors: [
        "animal",
        "bacteria",
        "cell_line",
        "fungi_yeast",
        "parasite",
        "plant",
      ],
    };
  },
  props: {
    bioUuid: { type: String, required: true },
    materialType: { type: String, required: true },
    materialTypeLabel: { type: String, required: true },
    groupNid: { type: String, default: "" },
    additionalId: { type: String, default: "" },
  },
  computed: {
    materialId() {
      return this.bioMaterial?.id;
    },
    popoverId() {
      return this.bioUuid + "-material-display-" + this.additionalId;
    },
    iconSearchId() {
      return this.bioUuid + "-icon-search-" + this.additionalId;
    },
  },
  methods: {
    async loadEntity() {
      this.isLoading = true;
      const path = "/entity-view-display/bio_material/" + this.materialType;
      const queries = { display_id: ["default"] };
      this.bioMaterials = {};
      try {
        const response = await restClient.get({ path, queries });
        this.displayData = response?.[this.materialType]?.default;
      } catch (e) {
        this.$emit("material-data-window-error", e);
        this.$showNotification(
          "error",
          "Unable to load entity. Please try again.",
        );
      } finally {
        this.isLoading = false;
      }
      const jpath = "/bio_material/" + this.materialType + "/" + this.bioUuid;

      const jqueries = {
        include: "og_audience,parent_reference",
        "fields[node--laboratory]": "title,drupal_internal__nid",
        "fields[node--department]": "title,drupal_internal__nid",
        "fields[node--raft_unit]": "title,drupal_internal__nid",
      };
      if (
        this.bioMaterialsSupportingPlasmidVectors.includes(this.materialType)
      ) {
        jqueries.include += ",field_biomat_plasmid_vector_type";
      }
      if (this.groupNid) {
        jqueries["rog-id"] = this.groupNid;
        jqueries["rog-type"] = "node";
      }
      const bioMaterialResponseData = await jsonClient
        .get({ path: jpath, queries: jqueries })
        .catch((e) => {
          this.$emit("material-data-window-error", e);
        });
      this.bioMaterial = bioMaterialResponseData?.deserialized;
    },
  },
  components: {
    RaftBusy,
    BioMaterialRender,
    BIconSearch,
    ErrorStateLinks,
  },
};
</script>

<style scoped>
.raft-js-bio-data-window-wrapper {
  display: inline-block;
}
</style>
